import { useCallback, useMemo, useState } from 'react';

import { useUserContext } from '@spacefill/shared/src/utils/contexts/UserContext';

import { AnalyticsChatPanel } from '../pages/analytics-chat/AnalyticsChatPanel';
import { AnalyticsChatPanelContext } from './useAnalyticsChatPanel';

export const AnalyticsChatPanelProvider = ({ children }) => {
    const { user } = useUserContext();
    const [isOpen, setIsOpen] = useState(false);
    const [isWorking, setIsWorking] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(null);
    const [hasUnreadReply, setHasUnreadReply] = useState(false);

    const openChat = useCallback(() => {
        setIsOpen(true);
        setHasUnreadReply(false);
    }, []);
    const closeChat = useCallback(() => setIsOpen(false), []);
    const markUnreadReply = useCallback(() => setHasUnreadReply(true), []);

    const value = useMemo(
        () => ({ openChat, closeChat, isWorking, loadingStatus, hasUnreadReply }),
        [openChat, closeChat, isWorking, loadingStatus, hasUnreadReply]
    );

    return (
        <AnalyticsChatPanelContext.Provider value={value}>
            {children}
            {user.features.askAnythingEnabled && (
                <AnalyticsChatPanel
                    isOpen={isOpen}
                    onClose={closeChat}
                    onWorkingChange={setIsWorking}
                    onLoadingStatusChange={setLoadingStatus}
                    onNewReplyWhileClosed={markUnreadReply}
                />
            )}
        </AnalyticsChatPanelContext.Provider>
    );
};
